<div class="hello-world">Hello World</div>

<button class="btn" (click)="saySomething()">Click Me</button>
